import { createReducer, on } from '@ngrx/store';
import { LoginDashboardState } from '../../models/states/login-dashboard.interfaces';
import * as fromLoginDashboardActions from '../actions/login-dashboard.actions';

export const LoginDashboardStateKey = 'loginDashboard';

const initialState: LoginDashboardState = {
  isReadyOnLanding: false,
  isError: false,
  accountCookieValue: null,
  isHipmunk: false,
  dashboardResponse: null
};

export const loginDashboardReducer = createReducer(
  initialState,
  on(
    fromLoginDashboardActions.StoreLoginDashboardInputValues,
    (state, { accountCookieValue, isHipmunk }) => ({
      ...state,
      accountCookieValue,
      isHipmunk
    })
  ),
  on(
    fromLoginDashboardActions.LoadDashboardLandingSuccess,
    (state, { dashboardResponse }) => ({
      ...state,
      isReadyOnLanding: true,
      isError: false,
      dashboardResponse
    })
  ),
  on(fromLoginDashboardActions.LoadDashboardLandingFailure, (state) => ({
    ...state,
    isReadyOnLanding: false,
    isError: true
  }))
);
